export function WhyChooseMFS() {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-8">
        <div className="text-center mb-14">
          <h2 className="text-3xl md:text-5xl font-black uppercase mb-4 text-foreground">
            Why Choose <span className="text-primary">MFS</span> Modular Systems?
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Better than traditional renovations in every way
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl mx-auto">
          {/* Card 1 - 100% Freestanding */}
          <div className="bg-gradient-to-br from-primary/5 to-primary/10 border-2 border-primary/20 p-8 rounded-xl hover:border-primary/50 hover:shadow-lg transition-all group">
            <div className="flex items-start gap-4">
              <div className="w-14 h-14 bg-primary/20 rounded-full flex items-center justify-center flex-shrink-0 group-hover:bg-primary/30 transition-colors">
                <svg className="w-7 h-7 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                </svg>
              </div>
              <div>
                <h3 className="text-xl font-black uppercase mb-2 text-foreground">100% Freestanding</h3>
                <p className="text-muted-foreground leading-relaxed">
                  It looks like a custom "built-in" office but isn't bolted down. Complete flexibility without permanent installation.
                </p>
              </div>
            </div>
          </div>

          {/* Card 2 - An Asset, Not an Expense */}
          <div className="bg-gradient-to-br from-yellow-50 to-yellow-100/50 border-2 border-yellow-200 p-8 rounded-xl hover:border-yellow-400 hover:shadow-lg transition-all group">
            <div className="flex items-start gap-4">
              <div className="w-14 h-14 bg-yellow-200 rounded-full flex items-center justify-center flex-shrink-0 group-hover:bg-yellow-300 transition-colors">
                <svg className="w-7 h-7 text-yellow-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <div>
                <h3 className="text-xl font-black uppercase mb-2 text-foreground">An Asset, Not an Expense</h3>
                <p className="text-muted-foreground leading-relaxed">
                  Since it's not a permanent renovation, you take your furniture with you when your lease is up. It's an investment that moves with you.
                </p>
              </div>
            </div>
          </div>

          {/* Card 3 - Perfect Aesthetic Match */}
          <div className="bg-gradient-to-br from-blue-50 to-blue-100/50 border-2 border-blue-200 p-8 rounded-xl hover:border-blue-400 hover:shadow-lg transition-all group">
            <div className="flex items-start gap-4">
              <div className="w-14 h-14 bg-blue-200 rounded-full flex items-center justify-center flex-shrink-0 group-hover:bg-blue-300 transition-colors">
                <svg className="w-7 h-7 text-blue-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 4a2 2 0 114 0v1a1 1 0 001 1h3a1 1 0 011 1v3a1 1 0 01-1 1h-1a2 2 0 100 4h1a1 1 0 011 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1v-1a2 2 0 10-4 0v1a1 1 0 01-1 1H7a1 1 0 01-1-1v-3a1 1 0 00-1-1H4a2 2 0 110-4h1a1 1 0 001-1V7a1 1 0 011-1h3a1 1 0 001-1V4z" />
                </svg>
              </div>
              <div>
                <h3 className="text-xl font-black uppercase mb-2 text-foreground">Perfect Aesthetic Match</h3>
                <p className="text-muted-foreground leading-relaxed">
                  Our "Add-on Modules" snap into existing setups, ensuring your office looks uniform even if you expand years later.
                </p>
              </div>
            </div>
          </div>

          {/* Card 4 - Zero Professional Fees */}
          <div className="bg-gradient-to-br from-green-50 to-green-100/50 border-2 border-green-200 p-8 rounded-xl hover:border-green-400 hover:shadow-lg transition-all group">
            <div className="flex items-start gap-4">
              <div className="w-14 h-14 bg-green-200 rounded-full flex items-center justify-center flex-shrink-0 group-hover:bg-green-300 transition-colors">
                <svg className="w-7 h-7 text-green-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <div>
                <h3 className="text-xl font-black uppercase mb-2 text-foreground">Zero Professional Fees</h3>
                <p className="text-muted-foreground leading-relaxed">
                  Skip the expensive designers and carpenters. Our modular systems are ready to use with simple assembly.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Comparison Table */}
        <ComparisonTable />
      </div>
    </section>
  );
}

function ComparisonTable() {
  return (
    <div className="mt-16 max-w-4xl mx-auto">
      <h3 className="text-2xl font-black uppercase mb-8 text-center text-foreground">
        MFS vs Traditional Carpentry
      </h3>
      <div className="overflow-hidden rounded-xl border-2 border-primary/20 shadow-lg">
        <table className="w-full">
          <thead>
            <tr className="bg-primary text-white">
              <th className="py-4 px-6 text-left font-black uppercase tracking-wider">Feature</th>
              <th className="py-4 px-6 text-center font-black uppercase tracking-wider bg-primary">
                <span className="flex items-center justify-center gap-2">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  MFS Modular
                </span>
              </th>
              <th className="py-4 px-6 text-center font-black uppercase tracking-wider bg-gray-600">
                <span className="flex items-center justify-center gap-2">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                  Traditional
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            {[
              { feature: 'Setup Time', mfs: 'Instant / No Downtime', trad: 'Weeks of Noise & Dust' },
              { feature: 'Portability', mfs: '100% Movable Asset', trad: 'Permanent (Left Behind)' },
              { feature: 'Cost', mfs: 'No Designer/Labour Fees', trad: 'Expensive Labour & Design' },
              { feature: 'Scalability', mfs: 'Easy "Add-on" Modules', trad: 'Difficult to Match Later' }
            ].map((row, i) => (
              <tr key={i} className={`border-b border-gray-200 hover:bg-primary/5 transition-colors ${i === 3 ? '' : 'border-b'}`}>
                <td className="py-5 px-6 font-bold text-foreground">{row.feature}</td>
                <td className="py-5 px-6 text-center bg-green-50">
                  <span className="text-green-700 font-semibold flex items-center justify-center gap-2">
                    <svg className="w-5 h-5 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                    {row.mfs}
                  </span>
                </td>
                <td className="py-5 px-6 text-center bg-red-50">
                  <span className="text-red-600 flex items-center justify-center gap-2">
                    <svg className="w-5 h-5 text-red-400" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                    </svg>
                    {row.trad}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
